import React, { useState, useEffect } from 'react';
import ArrowBack from '../Assets/arrow_back.svg';
import profilePics from '../Assets/applicant-pics.svg';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { CaseItem } from '../../Contexts/types';
import { useUserContext } from '../../Contexts/UserContext';
import { Button, Spin, message } from 'antd';

// import dayjs from 'dayjs';
// import utc from 'dayjs/plugin/utc';
// import timezone from 'dayjs/plugin/timezone';

// dayjs.extend(utc);
// dayjs.extend(timezone);

interface CaseDetailsProps {
  cases: CaseItem[];
}

export interface RulingApplication {
  caseId: string;
  case: Case
  digitalSeal: string;
  signature: string;
  approvalDocument: string[];
  id: string;
  approved: boolean;
  applicationType: string;
  applicationReason: string;
}
interface Case {
  suitNumber: string;
}

export interface CourtRecordsApplication {
  caseId: string;
  case: Case
  digitalSeal: string;
  signature: string;
  approvalDocument: string[];
  id: string;
  approved: boolean;
  applicationType: string;
}

export interface JudgementApplication {
  caseId: string;
  case: Case
  digitalSeal: string;
  signature: string;
  approvalDocument: string[];
  approved: boolean;
  id: string;
  applicationType: string;
}

const CaseDetails: React.FC<CaseDetailsProps> = ({ cases }) => {
  const { id } = useParams<{ id: string }>();
  const caseId = id;
  const caseDetails = cases.find((caseItem) => caseItem.basicData.id === id);
  const authToken = sessionStorage.getItem('token');
  const [rulingData, setRulingData] = useState<RulingApplication[]>([])
  const [judgementData, setJudgementData] = useState<JudgementApplication[]>([]);
  const [courtRecordsData, setCourtRecordsData] = useState<CourtRecordsApplication[]>([]);
  const [loading, setLoading] = useState(false);
  const { userData } = useUserContext();
  console.log(userData.userRole)
  const navigate = useNavigate();

  const InitiatePayment = async () => {
    setLoading(true); 
    try {
      const response = await fetch(`https://backend-kyw8.onrender.com/cases/initiate-payment`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${authToken}`,
          "Content-Type": "application/json" 
        },
        body: JSON.stringify({ caseId }),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const result = await response.json();
      console.log(result.message); 
  
      // Check if the result contains the data object with the link
      if (result.data && result.data.data.link) {
        console.log('Payment Link:', result.data.data.link);
        setTimeout(() => {
          window.location.href = result.data.data.link;
        }, 2000);
      } else {
        console.error('Payment link not found in the response.');
      }
    } catch (error) {
      console.error('Error initiating payment:', error);
    }finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    const getCourtRecordsApplications = async () => {
      try {
        const applicationResponse = await fetch(`https://backend-kyw8.onrender.com/court-records?caseId=${caseId}`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
  
        if (!applicationResponse.ok) {
          throw new Error('Network response was not ok');
        }
  
        const jsonData = await applicationResponse.json();
        console.log(jsonData);

        if (!jsonData) {
          console.warn("No applications found in the response.");
          return;
        }
        
        // Separate applications by type in a single iteration
        const applicationsByType = jsonData.data.reduce((acc, app) => {
          if (app.applicationType === 'COURT_RECORD') {
            acc.courtRecords.push(app);
          } else if (app.applicationType === 'JUDGEMENT') {
            acc.judgements.push(app);
          } else if (app.applicationType === 'RULING') {
            acc.rulings.push(app);
          }
          return acc;
        }, { courtRecords: [], judgements: [], rulings: [] });
  
        // Set state with filtered applications
        setCourtRecordsData(applicationsByType.courtRecords);
        setJudgementData(applicationsByType.judgements);
        setRulingData(applicationsByType.rulings);
  
        console.log("Court Records Data:", applicationsByType.courtRecords);
        console.log("Judgment Applications:", applicationsByType.judgements);
        console.log("Ruling Applications:", applicationsByType.rulings);
  
      } catch (error) {
        console.error('Error fetching court records applications:', error);
      }
    };
  
    getCourtRecordsApplications();
  }, [caseId, authToken]);
  
  if (!caseDetails) {
    message.error('Case not found');
  }

  function isSameDate(givenDate: Date | string | null): boolean {
    if (!givenDate) {
      return false;
    }
  
    const dateToCompare = new Date(givenDate); // Convert string to Date if necessary
  
    // Ensure the givenDate is valid before proceeding
    if (isNaN(dateToCompare.getTime())) {
      console.error('Invalid date');
      return false;
    }
  
    const today = new Date(); // Get today's date
  
    return (
      today.getFullYear() === dateToCompare.getFullYear() &&
      today.getMonth() === dateToCompare.getMonth() &&
      today.getDate() === dateToCompare.getDate()
    );
  }

  return (
    <div>
      <div className='flex w-full'>
        <Link to={'/'}>
          <img src={ArrowBack} alt='arrow-back' />
        </Link>
        <p className='text-[#222222] text-4xl font-bold text-center w-full'>
          Case Information
        </p>
      </div>
      <div className='mt-6 flex flex-col gap-[30px]'>
        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>Case Type:</p>
          <p className='text-[#222222] text-xl font-normal'>
            {caseDetails?.caseType?.title}
          </p>
        </div>

        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>Case Status:</p>
          <p className='text-[#222222] text-xl font-normal'>
            {caseDetails?.basicData?.status}
          </p>
        </div>
        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>SUIT NUMBER:</p>
          <p className='text-[#222222] text-xl font-normal'>
            {caseDetails?.basicData?.suitNumber}
          </p>
        </div>

        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>Parties:</p>
          <p className='text-[#222222] text-xl font-normal'>
            {caseDetails?.basicData?.title}
          </p>
        </div>

        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>Judge Name:</p>
          <p className='text-[#222222] text-xl font-normal'>
            {caseDetails?.judge?.fullName}
          </p>
        </div>

        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>
            Court Assigned:
          </p>
          <p className='text-[#222222] text-xl font-normal'>
            {caseDetails?.courtBasicData?.title}
          </p>
        </div>

        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>Next Adjourned Date:</p>
          <p className='text-[#222222] text-xl font-normal'>
            {caseDetails?.basicData?.nextSittingDate
              ? new Intl.DateTimeFormat('en-US', {
                  timeZone: 'UTC',
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: true,
                }).format(new Date(caseDetails.basicData.nextSittingDate))
              : 'Date not available'
            }
          </p>
        </div>
        {!caseDetails?.basicData?.paidStatus && userData.id === caseDetails?.createdBy.id &&(
          <div className='flex gap-3'>
            <p className='text-[#f90000] text-xl font-medium'>Payment Pending:</p>
            <p className='text-[#222222] text-xl font-normal'>
              Click <span className='text-[#f90000]'>
                <button 
                  onClick={InitiatePayment} 
                  disabled={loading} 
                  className={` ${loading ? <Spin size='small'/> : ''}`} 
                >
                  here
                </button>
              </span> to make payment
            </p>
          </div>
        )}
        {caseDetails?.basicData.paidStatus && isSameDate(caseDetails!.basicData.nextSittingDate) && (userData.userRole === 'JUDGE') && (
          <p className='text-[#222222] text-xl font-medium'>
            Start Court Session:{' '}
            <span className=''>
              <button
                onClick={() => {
                  navigate(`/court-live-session/${caseDetails.basicData.id}`, { state: { id: caseDetails.basicData.id, title: caseDetails.basicData.title } });
                }}
                className="text-blue-500 underline"
              >
                Here
              </button>
            </span>
          </p>
        )}

        {caseDetails?.basicData.paidStatus && isSameDate(caseDetails!.basicData.nextSittingDate) && (userData.userRole !== 'JUDGE') && (
          <p className='text-[#222222] text-xl font-medium'>
            Join Court Session:{' '}
            <span className=''>
              <button
                onClick={() => {
                  navigate(`/court-live-session/${caseDetails.basicData.id}`, { state: { id: caseDetails.basicData.id, title: caseDetails.basicData.title } });
                }}
                className="text-blue-500 underline"
              >
                Here
              </button>
            </span>
          </p>
        )}

      {/* Conditionally render loading spinner */}
      {loading && (
        <div className='flex items-center justify-center'>
          <div>
            <span className='visually-hidden'><Spin size='small'/></span>
          </div>
          <p className='ml-3'>Processing payment, please wait...</p>
        </div>
      )}

      {caseDetails?.basicData?.paidStatus && (
        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>Payment Status:</p>
          <p className='text-[#222222] text-xl font-normal'>
            Paid
          </p>
        </div>
      )}

        {(userData.userRole === 'JUDGE' || userData.userRole === 'LEGAL_REGISTRAR') && 
          <div className='flex gap-3'>
            <button 
              className='text-[#9B111E] text-xl underline font-medium'
              onClick={() => navigate(`/dashboard/edit-case-details/${caseDetails?.basicData.id}`, { state: { id: caseDetails?.basicData.id } })}
            >Update Case Status</button>
          </div>
        }
        
        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>Case Documents:</p>
          <Button className='text-[#222222] text-xl font-normal' onClick={() => navigate(`/dashboard/case-document/${id}`, { state: { id: id } })}>
            View Case Documents
          </Button>
        </div>
        {rulingData.length > 0 && (
          <div className="flex gap-3">
            <p className="text-[#222222] text-xl font-medium">Ruling Documents:</p>
            <Button className='text-[#222222] text-xl font-normal' onClick={() => navigate(`/dashboard/ruling-document/${id}`, { state: { id: id } })}>
              View Ruling Documents
            </Button>
          </div>
        )}
        {judgementData.length > 0 && (
          <div className="flex gap-3">
            <p className="text-[#222222] text-xl font-medium">Judgment Documents:</p>
            <Button className='text-[#222222] text-xl font-normal' onClick={() => navigate(`/dashboard/judgement-document/${id}`, { state: { id: id } })}>
              View Judgment Documents
            </Button>
          </div>
        )}
        {courtRecordsData.length > 0 && (
          <div className="flex gap-3">
            <p className="text-[#222222] text-xl font-medium">Court Records Documents:</p>
            <Button className='text-[#222222] text-xl font-normal' onClick={() => navigate(`/dashboard/court-records-document/${id}`, { state: { id: id } })}>
              View Court Records
            </Button>
          </div>
        )}

        {(userData.userRole === 'COUNSEL') && 
          <div className='flex flex-col md:flex-row gap-3'>
            <div>
              <Button
              onClick={() => navigate(`/dashboard/upload-more-document/${caseDetails?.basicData.id}`, { state: { id: caseDetails?.basicData.id } })}
            
              >Upload More Case Document</Button>
            </div>
            <div>
              <Button
                onClick={() => navigate(`/dashboard/apply-for-ruling`, { state: { id: caseDetails?.basicData.suitNumber } })}
              >Apply for Ruling</Button>
            </div>
            <div>
              <Button
                onClick={() => navigate(`/dashboard/apply-for-`, { state: { id: caseDetails?.basicData.suitNumber } })}
                >Apply for Judgment</Button>
            </div>
            <div>
              <Button
              onClick={() => navigate(`/dashboard/apply-for-records`, { state: { id: caseDetails?.basicData.suitNumber } })}
              >Apply for Court Records</Button>
            </div>
          </div>
        }
      </div>

      

      <div className='mt-[22px]'>
        {caseDetails?.claimants.map((claimant, index) => (
          <ProfileDetails key={`claimant-${index}`} person={claimant} role="Claimant" />
        ))}

        {caseDetails?.defendants.map((defendant, index) => (
          <ProfileDetails key={`defendant-${index}`} person={defendant} role="Defendant" />
        ))}

        {caseDetails?.claimantWitnesses.map((witness, index) => (
          <ProfileDetails key={`claimantWitness-${index}`} person={witness} role="Claimant Witness" />
        ))}

        {caseDetails?.defendantWitnesses.map((witness, index) => (
          <ProfileDetails key={`defendantWitness-${index}`} person={witness} role="Defendant Witness" />
        ))}
      </div>
    </div>
  );
};

interface ProfileDetailsProps {
  person: {
    firstName: string;
    middleName?: string;
    lastName: string;
    dateOfBirth?: string;
    mobile?: string;
    email?: string;
    address?: string;
  };
  role: string;
}

const ProfileDetails: React.FC<ProfileDetailsProps> = ({ person, role }) => (
  <div className='w-[95%]'>
    <p className='bg-[#222222] rounded-[10px] py-[11px] pl-4 text-[#9B111E] text-[23px] font-bold'>
      {role} Details
    </p>

    <div className='flex py-[30px] md:flex-row flex-col gap-5'>
      <img
        src={profilePics}
        alt='profile-pics'
        className='md:w-[357px] h-[267px] w-full'
      />
      <div className='flex flex-col gap-[30px]'>
        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>Name:</p>
          <p className='text-[#222222] text-xl font-normal'>
            {person.firstName} {person.middleName} {person.lastName}
          </p>
        </div>

        {/* <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>Date Of Birth:</p>
          <p className='text-[#222222] text-xl font-normal'>
            {person.dateOfBirth || 'N/A'}
          </p>
        </div> */}

        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>Phone Number:</p>
          <p className='text-[#222222] text-xl font-normal'>
            {person.mobile || 'N/A'}
          </p>
        </div>

        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>Email Address:</p>
          <p className='text-[#222222] text-xl font-normal'>
            {person.email || 'N/A'}
          </p>
        </div>

        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>Address:</p>
          <p className='text-[#222222] text-xl font-normal'>
            {person.address || 'N/A'}
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default CaseDetails;
